import {
  Config,
  Data,
  Puck,
  PuckComponent,
  Render,
  usePuck,
  type Slot,
} from "@measured/puck";
import "@measured/puck/puck.css";
import React, { ReactNode, useEffect, useState } from "react";
import { Dialog, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { renderToStaticMarkup, renderToString } from "react-dom/server";
import { DynamicIcon, IconName } from "lucide-react/dynamic";
// import cssFile from "../index.css";
import {
  initialData,
  paddingsArray,
  fontsArray,
  sizeFontsArray,
  alignItemsArray,
  iconsSizesArray,
  iconsNamesArray,
  trueFalseArray,
  justifyContentArray,
  textAlignArray,
  gapsArray,
  fontWeightsArray,
  classColorsArray,
  rightLeftArray,
} from "@pages/Contents/Corporate/Initiative/Editorial/utils/constants";
// import cssUrl from "./puck-editor.css";
import { convertToHtmlWithCss } from "@pages/Contents/Corporate/Initiative/Editorial/utils/html-converter";
import "./puck-editor.css";
import {
  ContentProps,
  HeroImageBackgroundProps,
  HeroImageSideProps,
  SectionCardsProps,
  SectionCardSummaryProps,
  SectionFlowCardsProps,
  SectionGovernanceProps,
  SectionLastCTAProps,
  SectionWithVideoProps,
} from "./interfaces";
import { Icon } from "../components/Icon";
import {
  downloadAndExtractColorsJson,
  downloadFile,
  getZipWithoutDownload,
  onErrorMessage,
  ServicesURL,
} from "@utils/utilsApi";
import { MethodType } from "src/services/type";
import { fetcher } from "src/services/config";
import useSWRMutation from "swr/mutation";
import { getEditorialById, submitCreateEditorial } from "../utils/utils";
import { useNavigate, useParams } from "react-router-dom";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { useFetchDataDetail, useFetchDetail } from "@hooks/useFetchDetail";
import { PagesID } from "@utils/utilsConfigurations";
import { unzipZipFile } from "@hooks/useUnzip";

const initialDomainColors = {
  backgroundAccent: "#0FD9FF",
  backgroundDisabled: "#C3C3C3",
  backgroundDisabledAlternative: "#696969",
  backgroundPrimary: "#1B1B1B",
  backgroundPrimaryCta: "#72CC52",
  backgroundPrimaryLighter: "#1B1B1B",
  backgroundPrimaryLighterAlternative: "#228000",
  backgroundSaved: "#FFFF00",
  backgroundSecondary: "#FFFFFF",
  backgroundSecondaryComplete: "#EEFFCD",
  backgroundWarning: "#FFF2D9",
  backgroundChatBotContainer: "#151515",
  inputBackground: "#FFFFFF",
  border: "#696969",
  borderAccent: "#D9D9D9",
  borderError: "#B61E06",
  borderPrimaryCta: "#228000",
  borderSecondaryComplete: "#7BBD00",
  borderTag: "#FFFFFF",
  borderGrayTag: "#CAC5C5",
  borderWarning: "#FFC03E",
  textDisabled: "#696969",
  textDisabledAlternative: "#D9D9D9",
  textError: "#BC5103",
  textPrimary: "#FFFFFF",
  textMandatory: "#0FD9FF",
  textPrimaryAlternative: "#151515",
  textPrimaryCta: "#151515",
  textInput: "#151515",
  textTag: "#323232",
  textWarning: "#EF880C",
  textFooter: "#FFFFFF",
  headerIcon: "#FFFFFF",
  textWidget: "#FFFFFF",
  textWidgetAlternative: "#151515",
  exploreCardText: "#FFFFFF",
  systemDisabled: "#D9D9D9",
  systemPrimary01: "#FFFFFF",
  systemPrimary01Alternative01: "#FFFFFF",
  systemPrimary01Alternative02: "#FFFFFF",
  systemPrimary02: "#F43E63",
  systemSecondary01: "#72CC52",
  systemSecondary02: "#165200",
  systemSecondary03: "#BC5103",
  systemSecondary05: "#151515",
  systemSecondary04: "#FFFF00",
  accentVariantA: "#72CC52",
  accentVariantB: "#165200",
  accentVariantC: "#BC5103",
  accentVariantD: "#0FD9FF",
  accentVariantE: "#FFFFFF",
  drawerWidgetBg: "#1B1B1B",
  white: "#FFFFFF",
  gradient01Start: "25,25,31,1",
  gradient02End: "27,27,27,1",
  gradient02Start: "27,27,27,0.3",
  gradient01End: "62,62,67,1",
  gradient03Start: "27,27,27,0.1",
  gradient03End: "27,27,27,0.7",
  gradient04Start: "27,27,27,0.4",
  gradient04End: "27,27,27,1",
  gradient05Start: "27,27,27,0",
  gradient05End: "27,27,27,0",
  gradient06Start: "27,27,27,0.4",
  gradient06End: "27,27,27,1",
  gradient07Start: "68,68,68,1",
  gradient07End: "27,27,27,1",
  gradient08Start: "27,27,27,0.5",
  gradient08End: "27,27,27,1",
  backgroundFooter: "#232323",
  backgroundSecondaryAlternative: "#D4F8FF",
  backgroundSecondaryHover: "255,255,255,0.1",
  backgroundPrimaryCtaHover: "#228000",
  backgroundCard: "#1B1B1B",
  backgroundSecondaryCtaHover: "#4A4A4A",
  borderPrimaryCtaHover: "#228000",
  borderPrimaryControl: "#4A4A4A",
  borderPrimaryControlHover: "#3A3A3A",
  backgroundPrimaryControl: "#2A2A2A",
  backgroundPrimaryControlHover: "#1A1A1A",
  backgroundPrimaryControlDisabled: "105,105,105,0.7",
  borderPrimaryControlDisabled: "74,74,74,0.7",
  textPrimaryControl: "#FFFFFF",
  textPrimaryControlDisabled: "255,255,255,0.7",
  systemSecondary01Hover: "#217901",
  backgroundError: "#FFCFC8",
};

// const domainColors = {
//   backgroundAccent: "#0FD9FF",
//   backgroundDisabled: "#C3C3C3",
//   backgroundDisabledAlternative: "#696969",
//   backgroundPrimary: "#1B1B1B",
//   backgroundPrimaryCta: "#0FD9FF",
//   backgroundPrimaryLighter: "#151515",
//   backgroundPrimaryLighterAlternative: "#151515",
//   backgroundSaved: "#FFFF00",
//   backgroundSecondary: "#FFFFFF",
//   backgroundSecondaryComplete: "#EEFFCD",
//   backgroundWarning: "#FFF2D9",
//   backgroundChatBotContainer: "#151515",
//   inputBackground: "#FFFFFF",
//   border: "#696969",
//   borderAccent: "#D9D9D9",
//   borderError: "#B61E06",
//   borderPrimaryCta: "#0FD9FF",
//   borderSecondaryComplete: "#7BBD00",
//   borderTag: "#FFFFFF",
//   borderGrayTag: "#CAC5C5",
//   borderWarning: "#FFC03E",
//   textDisabled: "#696969",
//   textDisabledAlternative: "#D9D9D9",
//   textError: "#FF6B00",
//   textPrimary: "#FFFFFF",
//   textMandatory: "#0FD9FF",
//   textPrimaryAlternative: "#151515",
//   textPrimaryCta: "#1B1B1B",
//   textInput: "#151515",
//   textTag: "#323232",
//   textWarning: "#FF6B00",
//   textFooter: "#FFFFFF",
//   headerIcon: "#FFFFFF",
//   textWidget: "#FFFFFF",
//   textWidgetAlternative: "#151515",
//   exploreCardText: "#FFFFFF",
//   systemDisabled: "#D9D9D9",
//   systemPrimary01: "#FFFFFF",
//   systemPrimary01Alternative01: "#FFFFFF",
//   systemPrimary01Alternative02: "#FFFFFF",
//   systemPrimary02: "#F43E63",
//   systemSecondary01: "#0FD9FF",
//   systemSecondary02: "#A7FF03",
//   systemSecondary03: "#BC5103",
//   systemSecondary05: "#151515",
//   systemSecondary04: "#FFFF00",
//   accentVariantA: "#0FD9FF",
//   accentVariantB: "#A7FF03",
//   accentVariantC: "#BC5103",
//   accentVariantD: "#0FD9FF",
//   accentVariantE: "#FFFFFF",
//   drawerWidgetBg: "#1B1B1B",
//   white: "#FFFFFF",
//   gradient01Start: "25,25,31,1",
//   gradient02End: "27,27,27,1",
//   gradient02Start: "27,27,27,0.3",
//   gradient01End: "62,62,67,1",
//   gradient03Start: "27,27,27,0.1",
//   gradient03End: "27,27,27,0.7",
//   gradient04Start: "27,27,27,0.4",
//   gradient04End: "27,27,27,1",
//   gradient05Start: "27,27,27,0.1",
//   gradient05End: "27,27,27,1",
//   gradient06Start: "27,27,27,0.4",
//   gradient06End: "27,27,27,1",
//   gradient07Start: "68,68,68,1",
//   gradient07End: "27,27,27,1",
//   gradient08Start: "27,27,27,0.5",
//   gradient08End: "27,27,27,1",
//   backgroundFooter: "#151515",
//   backgroundSecondaryAlternative: "#D4F8FF",
//   backgroundSecondaryHover: "255,255,255,0.1",
//   backgroundPrimaryCtaHover: "#0C95AF",
//   backgroundCard: "#1B1B1B",
//   backgroundSecondaryCtaHover: "#4A4A4A",
//   borderPrimaryCtaHover: "#098299",
//   borderPrimaryControl: "#4A4A4A",
//   borderPrimaryControlHover: "#3A3A3A",
//   backgroundPrimaryControl: "#2A2A2A",
//   backgroundPrimaryControlHover: "#1A1A1A",
//   backgroundPrimaryControlDisabled: "105,105,105,0.7",
//   borderPrimaryControlDisabled: "74,74,74,0.7",
//   textPrimaryControl: "#FFFFFF",
//   textPrimaryControlDisabled: "255,255,255,0.7",
//   systemSecondary01Hover: "#00B6D8",
//   backgroundError: "#FFCFC8"
// };

interface PuckEditorProps {
  isEditMode: boolean;
}

// Bottone Conferma nell'header — chiama save con i dati correnti di Puck.
const SaveButton: React.FC<{ onPublish: (data: any) => void; theme: any }> = ({
  onPublish,
  theme,
}) => {
  const { appState } = usePuck();
  return (
    <button
      className="puck-editor-close-btn"
      onClick={() => onPublish(appState.data)}
      title="Conferma"
      type="button"
      style={{
        marginLeft: "8px",
        border: `1px solid ${theme.palette.primary.main}`,
        backgroundColor: theme.palette.primary.main,
        color: "#fff",
      }}
    >
      Conferma
    </button>
  );
};

// Item root nell'Outline — seleziona il wrapper della pagina. Stile allineato ai Layer di Puck.
const RootOutlineItem: React.FC = () => {
  const { dispatch, appState } = usePuck();
  const isSelected = appState.ui.itemSelector === null;
  return (
    <button
      className={`outline-root-item${isSelected ? " outline-root-item--selected" : ""}`}
      onClick={() => dispatch({ type: "setUi", ui: { itemSelector: null } })}
      title="Seleziona Root (Pagina)"
      type="button"
    >
      <div className="outline-root-item__inner">
        <span className="outline-root-item__icon">
          <span className="outline-root-item__dot" />
        </span>
        <span className="outline-root-item__label">Root</span>
      </div>
    </button>
  );
};

// Inietta gli stili di scroll nell'iframe di Puck.
// Necessario via JS perché CopyHostStyles + useInjectGlobalCss aggiungono stili
// in modo asincrono, sovrascrivendo qualunque override CSS nel parent.
// Il MutationObserver mantiene il nostro <style> sempre ultimo nell'head.
const IframeResizer: React.FC<{
  document?: Document;
  children: React.ReactNode;
}> = ({ document: iframeDoc, children }) => {
  useEffect(() => {
    if (!iframeDoc?.head) return;
    const style = iframeDoc.createElement("style");
    style.dataset.editorialScrollFix = "1";
    style.textContent = `
      #frame-root { min-height: unset !important; height: auto !important; }
      html { height: 100% !important; overflow: hidden !important; }
      body { position: relative !important; height: 100% !important; overflow-y: auto !important; scrollbar-gutter: stable; }
    `;
    iframeDoc.head.appendChild(style);
    const mo = new MutationObserver(() => {
      if (iframeDoc.head.lastElementChild !== style) {
        iframeDoc.head.appendChild(style);
      }
    });
    mo.observe(iframeDoc.head, { childList: true });
    return () => {
      mo.disconnect();
      style.remove();
    };
  }, [iframeDoc]);
  return <>{children}</>;
};

const PuckEditor = ({ isEditMode }: PuckEditorProps) => {
  const theme = useTheme();
  const [selectedImage, setSelectedImage] = useState(null);
  const [textAreaData, setTextAreaData] = useState<string>("");
  const [dataToShow, setDataToShow] = useState<any>(initialData);
  const [domainColors, setDomainColors] = useState<any>(initialDomainColors);
  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    child?: ReactNode;
    message: string;
    description?: string;
  }>();

  //STYLE CSS
  const backgroundPrimary = {
    backgroundColor: domainColors.backgroundPrimary,
  };

  const backgroundFooter = {
    backgroundColor: domainColors.backgroundFooter,
  };

  const textPrimary = {
    color: domainColors.textPrimary,
  };

  const btnPrimary = {
    fontSsize: "18px",
    fontWeight: "600",
    borderRadius: "8px",
    cursor: "pointer",
    backgroundColor: domainColors.backgroundPrimaryCta,
    color: domainColors.textPrimaryCta,
    border: `2px solid ${domainColors.backgroundPrimaryCta}`,
  };

  const cardSummaryIcon: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "15px",
    padding: "20px",
    width: "200px",
    height: "400px",
    borderRadius: "8px",
  };

  const cardWithImage: React.CSSProperties = {
    display: "inline-flex",
    flexDirection: "column",
    width: "395px",
    height: "320px",
    justifyContent: "flex-end",
    alignItems: "flex-start",
    padding: "25px",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius: "16px",
  };

  const cardWithIcon: React.CSSProperties = {
    display: "inline-flex",
    flexDirection: "column",
    gap: "10px",
    padding: "16px 16px",
    borderRadius: "16px",
    justifyContent: "center",
    alignItems: "center",
    width: "280px",
    height: "280px",
    textAlign: "center",
  };

  const borders: React.CSSProperties = {
    border: `2px solid ${domainColors.border}`,
  };

  const backgroundColorsSection = [
    {
      label: "primary",
      value: domainColors.backgroundPrimary,
    },
    {
      label: "secondary",
      value: domainColors.backgroundFooter,
    },
  ];

  const { idInitiative, idEditorial, id: idCorporate } = useParams();

  const { columns, dataDetail, actionsForForms, mutate } = useFetchDataDetail(
    ServicesURL.groups.replace(
      ":idCorporate",
      idCorporate ? idCorporate : "1",
    ) + `/initiatives/${idInitiative}`,
  );

  useEffect(() => {
    const fileName = dataDetail?.name + "_BRANDASSET.zip";
    const fetchColorsJson = async () => {
      try {
        const colors = await downloadAndExtractColorsJson(
          `${ServicesURL.getDownloadSmartConfigurator}?corporateId=${idCorporate}&fileName=${fileName}&initiativeId=${idInitiative}`,
        );
        setDomainColors(colors);
      } catch (error) {
        console.error("Errore during downloading or extracting:", error);
      }
    };
    fetchColorsJson();
  }, [dataDetail]);

  useEffect(() => {
    const getEditorialForEdit = async () => {
      if (isEditMode && idEditorial) {
        const res = await getEditorialById(triggerGetEditorialForEdit);
        setDataToShow(JSON.parse(res.response?.data));
      }
    };
    getEditorialForEdit();
  }, [idEditorial]);

  // Create Puck component config
  const config: Config = {
    categories: {
      hero: {
        components: ["HeroImageBackground", "HeroImageSide"],
        defaultExpanded: false,
      },
      hidden: {
        components: [
          "Text",
          "Image",
          "Button",
          "Icon",
          "Spacing",
          "InputBar",
          "IFrameVideo",
          "CardWithImage",
          "CardWithIcon",
        ],
        visible: false,
      },
      other: {
        title: "Other components",
      },
    },
    components: {
      HeroImageBackground: {
        fields: {
          titleHero: {
            type: "text",
          },
          descriptionHero: {
            type: "text",
          },
          button: {
            type: "text",
          },
          buttonUrl: {
            type: "text",
            label: "URL Bottone",
          },
          urlBackground: {
            type: "text",
          },
          blur: {
            type: "select",
            options: trueFalseArray,
          },
        },
        defaultProps: {
          titleHero: "Title Hero",
          descriptionHero: "description Hero",
          button: "Button",
          buttonUrl: "",
          urlBackground:
            "https://static.vecteezy.com/system/resources/thumbnails/057/068/323/small/single-fresh-red-strawberry-on-table-green-background-food-fruit-sweet-macro-juicy-plant-image-photo.jpg",
          blur: true,
        },
        render: (({
          titleHero,
          descriptionHero,
          button,
          buttonUrl,
          urlBackground,
          blur,
        }: HeroImageBackgroundProps) => {
          return (
            <div
              className="hero-container editorial-hero-bg"
              style={{
                backgroundImage: `${blur ? "linear-gradient(rgba(0, 0, 0, 0.30), rgba(0, 0, 0, 0.30))," : ""} url(${urlBackground})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span className="hero-title">{titleHero}</span>
              <span className="hero-desc">{descriptionHero}</span>
              {button !== "" &&
                (buttonUrl ? (
                  <a
                    href={buttonUrl}
                    style={{ textDecoration: "none", marginTop: "24px" }}
                  >
                    <button className="md" style={{ ...btnPrimary }}>
                      {button}
                    </button>
                  </a>
                ) : (
                  <button
                    className="md"
                    style={{ ...btnPrimary, marginTop: "24px" }}
                  >
                    {button}
                  </button>
                ))}
            </div>
          );
        }) as PuckComponent<HeroImageBackgroundProps>,
      },
      HeroImageSide: {
        fields: {
          title: {
            type: "text",
          },
          description: {
            type: "text",
          },
          button: {
            type: "text",
          },
          buttonUrl: {
            type: "text",
            label: "URL Bottone",
          },
          urlBackground: {
            type: "text",
          },
          positionImage: {
            type: "select",
            options: rightLeftArray,
          },
        },
        defaultProps: {
          title: "Lorem ipsum",
          description: "lorem ipsum description",
          button: "button",
          buttonUrl: "",
          positionImage: "right",
          urlBackground:
            "https://static.vecteezy.com/system/resources/thumbnails/057/068/323/small/single-fresh-red-strawberry-on-table-green-background-food-fruit-sweet-macro-juicy-plant-image-photo.jpg",
          blur: true,
        },
        render: (({
          title,
          description,
          button,
          buttonUrl,
          urlBackground,
          positionImage,
        }: HeroImageSideProps) => {
          return (
            <div
              className="editorial-hero-side"
              style={{
                display: "flex",
                flexDirection: `${positionImage === "right" ? "row" : "row-reverse"}`,
              }}
            >
              <div
                style={{
                  flex: "1",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: "15px",
                }}
              >
                <h1>{title}</h1>
                <span>{description}</span>
                {button !== "" && (
                  <div>
                    {buttonUrl ? (
                      <a href={buttonUrl} style={{ textDecoration: "none" }}>
                        <button
                          className="md"
                          style={{ ...btnPrimary, marginTop: "24px" }}
                        >
                          {button}
                        </button>
                      </a>
                    ) : (
                      <button
                        className="md"
                        style={{ ...btnPrimary, marginTop: "24px" }}
                      >
                        {button}
                      </button>
                    )}
                  </div>
                )}
              </div>
              <div
                style={{
                  flex: "1.2",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  src={urlBackground}
                  title="Video player"
                  width="600px"
                  height="350px"
                  style={{ borderRadius: "15px" }}
                ></img>
              </div>
            </div>
          );
        }) as PuckComponent<HeroImageSideProps>,
      },
      SectionWithVideo: {
        fields: {
          positionVideo: {
            type: "select",
            options: rightLeftArray,
          },
          title: {
            type: "text",
          },
          description: {
            type: "text",
          },
          videoUrl: {
            type: "text",
          },
          button: {
            type: "text",
          },
        },
        defaultProps: {
          title: "Lorem ipsum",
          description:
            "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Magnam, numquam! Nisi deserunt porro quia facilis qui delectus molestiae perspiciatis mollitia quisquam odio laudantium eum iusto, assumenda maiores dolore vero unde?",
          positionVideo: "right",
          videoUrl:
            "https://www.youtube.com/embed/5XH6qe4e_ys?si=dNahjEGfhqdKLzdS",
          button: "",
        },
        render: (({
          positionVideo,
          videoUrl,
          title,
          description,
          button,
        }: SectionWithVideoProps) => (
          <div
            className="editorial-section-video"
            style={{
              display: "flex",
              flexDirection: `${positionVideo === "right" ? "row" : "row-reverse"}`,
            }}
          >
            <div
              style={{
                flex: "1",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                gap: "15px",
              }}
            >
              <h1>{title}</h1>
              <span>{description}</span>
              {button !== "" && (
                <div>
                  <button
                    className="md"
                    style={{ ...btnPrimary, marginTop: "24px" }}
                  >
                    {button}
                  </button>
                </div>
              )}
            </div>
            <div
              style={{
                flex: "1.2",
                display: "flex",
                alignItems: "center",
              }}
            >
              <iframe
                src={videoUrl}
                title="Video player"
                width="600px"
                height="350px"
                style={{ borderRadius: "15px" }}
              ></iframe>
            </div>
          </div>
        )) as PuckComponent<SectionWithVideoProps>,
      },
      // Layout
      Spacing: {
        fields: {
          width: {
            type: "select",
            options: paddingsArray,
          },
          height: {
            type: "select",
            options: paddingsArray,
          },
        },
        defaultProps: {
          width: "24px",
          height: "24px",
        },
        render: (({ height, width }: { height: string; width: string }) => {
          return <div style={{ height: `${height}`, width: `${width}` }}></div>;
        }) as PuckComponent<{
          height: string;
          width: string;
        }>,
      },
      // Cards
      SectionFlowCards: {
        fields: {
          cards: {
            type: "array",
            max: 3,
            arrayFields: {
              title: {
                type: "text",
              },
              description: {
                type: "text",
              },
              icon: {
                type: "select",
                options: iconsNamesArray,
              },
            },
            defaultItemProps: {
              icon: "book",
              title: "Title Card",
              description: "description",
            },
          },
          title: {
            type: "text",
          },
          description: {
            type: "text",
          },
        },
        defaultProps: {
          title: "Lorem ipsum",
          description: "lorem ipsum description",
          cards: [
            {
              icon: "book",
              title: "Title Card",
              description: "description",
            },
            {
              icon: "building",
              title: "Title Card",
              description: "description",
            },
          ],
        },
        render: (({ title, description, cards }: SectionFlowCardsProps) => (
          <div
            className="editorial-flow-outer"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: "30px",
            }}
          >
            <h1 style={{ marginTop: "10px" }}>{title}</h1>
            <span style={{ marginTop: "15px" }}>{description}</span>
            <div className="editorial-flow-cards-row">
              {cards.map((card, index) => (
                <>
                  {index > 0 && (
                    <div
                      key={"arrow-card-flow-" + index}
                      className="editorial-flow-arrow"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Icon
                        name={"arrow-right"}
                        color={domainColors.backgroundPrimaryCta}
                        size={72}
                      />
                    </div>
                  )}
                  <div
                    key={"card-flow-" + index}
                    className="editorial-flow-card"
                    data-flow-index={index}
                    style={{
                      ...borders,
                      ...cardWithIcon,
                      ...backgroundPrimary,
                    }}
                  >
                    <Icon
                      name={card.icon}
                      color={domainColors.backgroundPrimaryCta}
                      size={48}
                    />
                    <div className="editorial-flow-card__text">
                      <span>{card.title}</span>
                      <span>{card.description}</span>
                    </div>
                  </div>
                </>
              ))}
            </div>
          </div>
        )) as PuckComponent<SectionFlowCardsProps>,
      },
      SectionCards: {
        fields: {
          title: {
            type: "text",
          },
          description: {
            type: "text",
          },
          cards: {
            type: "array",
            arrayFields: {
              backgroundImageUrl: {
                type: "text",
              },
              icon: {
                type: "select",
                options: iconsNamesArray,
              },
              title: {
                type: "text",
              },
              description: {
                type: "text",
              },
            },
            defaultItemProps: {
              icon: "leaf",
              title: "ESG",
              description:
                "Approfondisci i principi della sostenibilità ambientale, sociale e di governance per strategie aziendali responsabili.",
              backgroundImageUrl:
                "https://economiacircolare.com/wp-content/uploads/2025/03/pale-eoliche-1068x657.png",
            },
          },
        },
        defaultProps: {
          title: "Lorem ipsum dolor sit amet",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          cards: [
            {
              icon: "building",
              title: "Lorem ipsum",
              description:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
              backgroundImageUrl: "",
            },
            {
              icon: "leaf",
              title: "Lorem ipsum",
              description:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
              backgroundImageUrl: "",
            },
            {
              icon: "shield",
              title: "Lorem ipsum",
              description:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
              backgroundImageUrl: "",
            },
          ],
        },
        render: (({ title, description, cards }: SectionCardsProps) => (
          <div
            className="editorial-section-cards-outer"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "15px",
              alignItems: "center",
              padding: "30px",
            }}
          >
            <span style={{ fontSize: "28px" }}>{title}</span>
            <span style={{ fontSize: "16px" }}>{description}</span>
            <div className="editorial-section-cards-grid">
              {cards.map((card, i) => (
                <div
                  key={"card-with-image-" + i}
                  className="editorial-card-with-image"
                  style={{
                    ...borders,
                    display: "inline-flex",
                    flexDirection: "column",
                    justifyContent: "flex-end",
                    alignItems: "flex-start",
                    padding: "25px",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    borderRadius: "16px",
                    backgroundImage: `linear-gradient(
                  rgba(0, 0, 0, 0.50),
                  rgba(0, 0, 0, 0.50)
                ), url(${card.backgroundImageUrl})`,
                  }}
                >
                  <DynamicIcon
                    name={card.icon}
                    color={domainColors.exploreCardText}
                    size={48}
                  />
                  <span>{card.title}</span>
                  <span>{card.description}</span>
                </div>
              ))}
            </div>
          </div>
        )) as PuckComponent<SectionCardsProps>,
      },
      SectionGovernance: {
        fields: {
          title: {
            type: "text",
          },
          cards: {
            type: "array",
            max: 3,
            arrayFields: {
              number: {
                type: "number",
              },
              title: {
                type: "text",
              },
              description: {
                type: "text",
              },
            },
            defaultItemProps: {
              number: "1",
              title: "Academy Committee",
              description: "Strategia e allocazione del budget",
            },
          },
        },
        defaultProps: {
          title: "Lorem ipsum dolor sit amet",
          cards: [
            {
              number: "1",
              title: "Lorem ipsum",
              description:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            },
          ],
        },
        render: (({ title, cards }: SectionGovernanceProps) => (
          <div
            className="editorial-governance-outer"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "40px",
            }}
          >
            <span
              style={{
                textAlign: "center",
                fontSize: "28px",
                fontWeight: "700px",
                width: "80%",
                paddingBottom: "20px",
                borderBottom: `2px solid ${domainColors.border}`,
              }}
            >
              {title}
            </span>
            <div className="editorial-governance-row">
              {cards.map((card, i) => (
                <div
                  key={"card-governance-" + i}
                  className="editorial-governance-card"
                  style={{
                    padding: "25px",
                    border: `2px solid ${domainColors.border}`,
                    borderRadius: "16px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                      fontWeight: "600px",
                    }}
                  >
                    <div
                      style={{
                        padding: "20px",
                        backgroundColor: `${domainColors.backgroundPrimaryCta}`,
                        width: "20px",
                        height: "20px",
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      1
                    </div>
                    <div>{card.title}</div>
                  </div>
                  <div>{card.description}</div>
                </div>
              ))}
            </div>
          </div>
        )) as PuckComponent<SectionGovernanceProps>,
      },
      SectionCardSummary: {
        fields: {
          title: {
            type: "text",
          },
          description: {
            type: "text",
          },
          cards: {
            type: "array",
            max: 5,
            arrayFields: {
              icon: {
                type: "select",
                options: iconsNamesArray,
              },
              title: {
                type: "text",
              },
              description: {
                type: "text",
              },
            },
            defaultItemProps: {
              icon: "graduation-cap",
              title: "Back to class",
              description:
                "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Placeat deserunt, ducimus porro facilis tempora deleniti culpa et",
            },
          },
        },
        defaultProps: {
          title: "Lorem ipsum dolor sit amet",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          cards: [
            {
              icon: "graduation-cap",
              title: "Lorem ipsum",
              description:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Placeat deserunt ducimus porro facilis tempora.",
            },
            {
              icon: "user",
              title: "Lorem ipsum",
              description:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Placeat deserunt ducimus porro facilis tempora.",
            },
            {
              icon: "message-circle",
              title: "Lorem ipsum",
              description:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Placeat deserunt ducimus porro facilis tempora.",
            },
          ],
        },
        render: (({ title, description, cards }: SectionCardSummaryProps) => (
          <div
            className="editorial-card-summary-outer"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "15px",
              alignItems: "center",
              padding: "30px",
              textAlign: "center",
              backgroundColor: domainColors.backgroundFooter,
            }}
          >
            <span style={{ fontSize: "28px" }}>{title}</span>
            <span style={{ fontSize: "16px" }}>{description}</span>
            <div className="editorial-card-summary-row">
              {cards.map((card, i) => (
                <div
                  key={"card-summary-icon-" + i}
                  className="editorial-card-summary-item"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "15px",
                    padding: "20px",
                    borderRadius: "8px",
                    backgroundColor: domainColors.backgroundPrimary,
                  }}
                >
                  <DynamicIcon
                    size={36}
                    name={card.icon}
                    color={domainColors.backgroundPrimaryCta}
                    style={{ marginTop: "40px" }}
                  />
                  <span style={{ fontSize: "18px", fontWeight: "600" }}>
                    {card.title}
                  </span>
                  <span style={{ fontSize: "14px" }}>{card.description}</span>
                </div>
              ))}
            </div>
          </div>
        )) as PuckComponent<SectionCardSummaryProps>,
      },
      SectionLastCTA: {
        fields: {
          button: {
            type: "text",
          },
          link: {
            type: "text",
          },
          description: {
            type: "text",
          },
        },
        defaultProps: {
          button: "Lorem ipsum",
          link: "",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        },
        render: (({ button, link, description }) => (
          <div
            style={{
              padding: "40px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "40px",
            }}
          >
            {button && link && (
              <a href={link} style={{ textDecoration: "none" }}>
                <button
                  className="md"
                  style={{
                    ...btnPrimary,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  {button} <DynamicIcon name={"arrow-right"} size={20} />
                </button>
              </a>
            )}
            {button && !link && (
              <button
                className="md"
                style={{
                  ...btnPrimary,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                {button} <DynamicIcon name={"arrow-right"} size={20} />
              </button>
            )}
            <span>{description}</span>
          </div>
        )) as PuckComponent<SectionLastCTAProps>,
      },
      // Base
      Text: {
        fields: {
          text: {
            type: "text",
          },
          font: {
            type: "select",
            options: fontsArray,
          },
          size: {
            type: "select",
            options: sizeFontsArray,
          },
          textAlign: {
            type: "select",
            options: textAlignArray,
          },
        },
        defaultProps: {
          font: "Inter",
          size: "28px",
          text: "text",
        },
        render: (({
          text,
          font,
          size,
          textAlign,
        }: {
          text: string;
          font: string;
          size: string;
          textAlign: React.CSSProperties["textAlign"];
        }) => {
          return (
            <p
              style={{
                fontSize: `${size}`,
                fontFamily: `${font}`,
                ...(textAlign && { textAlign }),
              }}
            >
              {text}
            </p>
          );
        }) as PuckComponent<{
          text: string;
          font: string;
          size: string;
          textAlign: React.CSSProperties["textAlign"];
        }>,
      },
      Image: {
        fields: {
          url: {
            type: "text",
          },
          alt: {
            type: "text",
          },
        },
        render: (({ url, alt }: { url: string; alt: string }) => {
          return <img src={url} alt={alt} width="100%" height="100%" />;
        }) as PuckComponent<{
          url: string;
          alt: string;
        }>,
      },
      // The icons that are used are from lucide
      Icon: {
        fields: {
          iconName: {
            type: "select",
            options: iconsNamesArray,
          },
          iconSize: {
            type: "select",
            options: iconsSizesArray,
          },
          iconColor: {
            type: "select",
            options: classColorsArray,
          },
        },
        defaultProps: {
          iconName: "book",
          iconSize: 24,
          iconColor: "texts-color",
        },
        render: (({
          iconName,
          iconSize,
          iconColor,
        }: {
          iconName: IconName;
          iconSize: string;
          iconColor: string;
        }) => {
          return <Icon name={iconName} size={Number(iconSize)} />;
        }) as PuckComponent<{
          iconName: IconName;
          iconSize: string;
          iconColor: string;
        }>,
      },
      InputBar: {
        fields: {
          verticalPadding: {
            type: "select",
            options: paddingsArray,
          },
          horizontalPadding: {
            type: "select",
            options: paddingsArray,
          },
          fontSize: {
            type: "select",
            options: sizeFontsArray,
          },
          roundedCorners: {
            type: "select",
            options: trueFalseArray,
          },
          value: {
            type: "text",
          },
        },
        defaultProps: {
          fontSize: "24px",
          roundedCorners: false,
          value: "Input",
        },
        render: (({
          verticalPadding,
          horizontalPadding,
          fontSize,
          roundedCorners,
          value,
        }: {
          verticalPadding: string;
          horizontalPadding: string;
          fontSize: string;
          roundedCorners: string;
          value: string;
        }) => (
          <input
            style={{
              padding: `${verticalPadding} ${horizontalPadding}`,
              fontSize: `${fontSize}`,
              borderRadius: `${roundedCorners ? "8px" : "0px"}`,
            }}
            value={value}
          />
        )) as PuckComponent<{
          verticalPadding: string;
          horizontalPadding: string;
          fontSize: string;
          roundedCorners: string;
          value: string;
        }>,
      },
      Button: {
        fields: {
          text: {
            type: "text",
          },
          size: {
            type: "select",
            options: [
              { label: "small", value: "sm" },
              { label: "medium", value: "md" },
              { label: "large", value: "lg" },
            ],
          },
          type: {
            type: "select",
            options: [
              { label: "primary", value: "primary" },
              { label: "secondary", value: "secondary" },
              { label: "tertiary", value: "tertiary" },
            ],
          },
        },
        defaultProps: {
          text: "button",
          size: "sm",
          type: "primary",
        },
        render: (({
          text,
          size,
          type,
        }: {
          text: string;
          size: string;
          type: string;
        }) => {
          return (
            <button className={`${size} ${type}`} style={{ ...btnPrimary }}>
              {text}
            </button>
          );
        }) as PuckComponent<{
          text: string;
          size: string;
          type: string;
        }>,
      },
      IFrameVideo: {
        fields: {
          url: {
            type: "text",
          },
          width: {
            type: "text",
          },
          height: {
            type: "text",
          },
        },
        defaultProps: {
          width: "420",
          height: "315",
        },
        render: (({
          url,
          width,
          height,
        }: {
          url: string;
          width: string;
          height: string;
        }) => {
          return (
            <iframe
              width={width}
              height={height}
              src={url}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          );
        }) as PuckComponent<{
          url: string;
          width: string;
          height: string;
        }>,
      },
    },
    root: {
      fields: {
        bgColor: {
          type: "custom",
          render: ({ value, onChange }: any) => (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "8px" }}
            >
              <label
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "var(--puck-editor-text, #374151)",
                }}
              >
                Colore sfondo pagina
              </label>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <input
                  type="color"
                  value={value || domainColors.backgroundPrimaryLighter}
                  onChange={(e) => onChange(e.target.value)}
                  style={{
                    cursor: "pointer",
                    width: "32px",
                    height: "32px",
                    padding: "0",
                    border: "1px solid var(--puck-editor-border, #e5e7eb)",
                    borderRadius: "4px",
                  }}
                />
                <input
                  type="text"
                  value={value || domainColors.backgroundPrimaryLighter}
                  onChange={(e) => onChange(e.target.value)}
                  style={{
                    fontSize: "13px",
                    padding: "6px",
                    width: "100px",
                    border: "1px solid var(--puck-editor-border, #e5e7eb)",
                    borderRadius: "4px",
                    color: "var(--puck-editor-text, #374151)",
                    background: "var(--puck-color-white, #fff)",
                  }}
                />
              </div>
              {value && (
                <button
                  type="button"
                  onClick={() => onChange("")}
                  style={{
                    marginTop: "6px",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px",
                    fontSize: "12px",
                    fontWeight: 600,
                    padding: "5px 10px",
                    border: "1px solid var(--puck-editor-border, #e5e7eb)",
                    borderRadius: "4px",
                    cursor: "pointer",
                    color: "var(--puck-editor-text, #374151)",
                    background: "var(--puck-color-white, #fff)",
                    width: "100%",
                    justifyContent: "center",
                  }}
                >
                  ↺ Ripristina colore default
                </button>
              )}
            </div>
          ),
        },
      },
      defaultProps: {
        bgColor: "",
      },
      render: ({
        children,
        bgColor,
      }: {
        children: React.ReactNode;
        bgColor?: string;
      }) => {
        return (
          <main
            className="editorial-root"
            style={{
              fontFamily: "Inter",
              backgroundColor: bgColor || domainColors.backgroundPrimaryLighter,
              color: domainColors.textPrimary,
            }}
          >
            {children}
          </main>
        );
      },
    },
  };

  const { trigger: triggerGetEditorialForEdit } = useSWRMutation(
    `${ServicesURL.editorial}/${idEditorial}`,
    (url: string, { arg }: { arg: any }) => {
      return fetcher<any>(url, MethodType.GET, arg);
    },
  );

  const { trigger: triggerCreateEditorial } = useSWRMutation(
    `${ServicesURL.editorial}`,
    (url: string, { arg }: { arg: any }) => {
      return fetcher<any>(url, MethodType.POST, arg);
    },
  );

  const { trigger: triggerEditEditorial } = useSWRMutation(
    `${ServicesURL.editorial}`,
    (url: string, { arg }: { arg: any }) => {
      return fetcher<any>(url, MethodType.PUT, arg);
    },
  );

  // Save the data to your database
  const save = async (data: Partial<Data>) => {
    const html = renderToStaticMarkup(<Render config={config} data={data} />);

    setOpenToast({ s: StatusEnum.LOADING, message: "loading" });
    try {
      if (isEditMode) {
        await submitCreateEditorial(
          {
            name: data?.root?.props?.title,
            data: JSON.stringify(data),
            html: html,
            initiative_id: idInitiative,
            id: idEditorial,
          },
          triggerEditEditorial,
        );
      } else {
        await submitCreateEditorial(
          {
            name: data?.root?.props?.title,
            data: JSON.stringify(data),
            html: html,
            initiative_id: idInitiative,
            corporate_id: idCorporate,
          },
          triggerCreateEditorial,
        );
      }
      setOpenToast({ s: StatusEnum.OK, child: null, message: "" });
    } catch (error) {
      const message = onErrorMessage(error);
      setOpenToast({ s: StatusEnum.KO, message: message });
      console.error(error);
    }
  };

  const navigate = useNavigate();

  const [confirmClose, setConfirmClose] = useState(false);
  const handleCloseRequest = () => setConfirmClose(true);
  const handleCloseConfirmed = () => {
    setConfirmClose(false);
    navigate(-1);
  };

  return (
    <>
      <Dialog fullScreen open={true} onClose={handleCloseRequest}>
        <div
          className="puck-editor-root"
          style={
            {
              display: "flex",
              flexDirection: "column",
              width: "100%",
              height: "100%",
              "--puck-color-azure-04": theme.palette.primary.main,
              "--puck-color-azure-05": theme.palette.primary.dark,
              "--puck-color-azure-06": alpha(theme.palette.primary.main, 0.55),
              "--puck-color-azure-07": alpha(theme.palette.primary.main, 0.4),
              "--puck-color-azure-08": alpha(theme.palette.primary.main, 0.28),
              "--puck-color-azure-09": alpha(theme.palette.primary.main, 0.18),
              "--puck-color-azure-10": alpha(theme.palette.primary.main, 0.1),
              "--puck-color-azure-11": alpha(theme.palette.primary.main, 0.05),
              "--puck-color-azure-12": alpha(theme.palette.primary.main, 0.08),
              "--puck-color-indigo-04": theme.palette.primary.main,
              "--puck-color-black": theme.palette.text.primary,
              "--puck-color-white": theme.palette.background.paper,
              "--puck-color-grey-01": theme.palette.text.primary,
              "--puck-color-grey-02": theme.palette.text.primary,
              "--puck-color-grey-03": theme.palette.text.secondary,
              "--puck-color-grey-04": theme.palette.text.secondary,
              "--puck-color-grey-05": theme.palette.text.disabled || "#9ca3af",
              "--puck-color-grey-06": theme.palette.text.disabled || "#9ca3af",
              "--puck-color-grey-07": theme.palette.divider,
              "--puck-color-grey-08": theme.palette.divider,
              "--puck-color-grey-09": theme.palette.divider,
              "--puck-color-grey-10": theme.palette.background.default,
              "--puck-color-grey-11": theme.palette.background.default,
              "--puck-color-grey-12": theme.palette.background.paper,
              "--puck-color-grey-13": theme.palette.background.default,
              "--puck-editor-text": theme.palette.text.primary,
              "--puck-editor-text-muted":
                theme.palette.text.disabled || "#9ca3af",
              "--puck-editor-bg-hover": theme.palette.background.default,
              "--puck-editor-border": theme.palette.divider,
              "--puck-editor-primary": theme.palette.primary.main,
            } as React.CSSProperties
          }
        >
          <Puck
            key={JSON.stringify(dataToShow)}
            config={config}
            data={dataToShow}
            onPublish={save}
            overrides={{
              outline: ({ children }) => (
                <div>
                  <RootOutlineItem />
                  {children}
                </div>
              ),
              iframe: ({ document, children }) => (
                <IframeResizer document={document}>{children}</IframeResizer>
              ),
              headerActions: ({ children: _children }) => (
                <>
                  <SaveButton onPublish={save} theme={theme} />
                  <button
                    className="puck-editor-close-btn"
                    type="button"
                    onClick={handleCloseRequest}
                    title="Chiudi Editor"
                    style={{
                      marginLeft: "8px",
                      border: `1px solid ${theme.palette.divider}`,
                      backgroundColor: theme.palette.background.paper,
                      color: theme.palette.text.primary,
                    }}
                  >
                    Chiudi
                  </button>
                </>
              ),
            }}
          />
        </div>
      </Dialog>

      {/* Conferma chiusura senza salvare */}
      <ModalConfirmsCst
        open={confirmClose}
        title={""}
        description={"Sei sicuro di voler uscire senza salvare?"}
        onCallBackClosed={() => setConfirmClose(false)}
        onActionConfirmed={handleCloseConfirmed}
      />

      {/* Toast salvataggio */}
      <ModalConfirmsCst
        open={!!openToast}
        title={""}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
        }}
        status={openToast}
      />
    </>
  );
};

export default PuckEditor;
